import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'
import { LegacyCardTemplate } from './variants/LegacyCard'
import { LegacyCommentsTemplate } from './variants/LegacyComments'
import { LegacyCompactTemplate } from './variants/LegacyCompact'
import { LegacyEmailTemplate } from './variants/LegacyEmail'
import { LegacyStdTemplate } from './variants/LegacyStd'
import { CardsSlideTemplate } from './variants/CardsSlide'

const legacyCompactVariant = {
  ...productRowVariantForPath('std', 1),
  Template: LegacyCompactTemplate,
} as const satisfies RowVariantDefinition

const legacyCommentsVariant = {
  ...productRowVariantForPath('std', 2),
  Template: LegacyCommentsTemplate,
} as const satisfies RowVariantDefinition

const legacyCardVariant = {
  ...productRowVariantForPath('std', 3),
  Template: LegacyCardTemplate,
} as const satisfies RowVariantDefinition

const legacyStdVariant = {
  ...productRowVariantForPath('std', 4),
  Template: LegacyStdTemplate,
} as const satisfies RowVariantDefinition

const legacyEmailVariant = {
  ...productRowVariantForPath('std', 6),
  Template: LegacyEmailTemplate,
} as const satisfies RowVariantDefinition

const cardsSlideVariant = {
  ...productRowVariantForPath('std', 7),
  Template: CardsSlideTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('std')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [
      legacyCompactVariant,
      legacyCommentsVariant,
      legacyCardVariant,
      legacyStdVariant,
      legacyEmailVariant,
      cardsSlideVariant,
      sharedChatAnswerVariant,
    ],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [
      legacyCompactVariant,
      legacyCommentsVariant,
      legacyCardVariant,
      legacyStdVariant,
      legacyEmailVariant,
      cardsSlideVariant,
    ],
    fallback: productRows.submsges.fallback,
  },
})
